import FileSystemObjectType from '@/enums/FileSystemObjectType';
import DirectoryFactory from '@/factories/DirectoryFactory';

class FileSystemFactory
{
	public static create(options: any)
	{
		if (options && options.type === FileSystemObjectType.Directory)
		{
			return DirectoryFactory.create(null, options);
		}
	}
}

export default FileSystemFactory;